var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-product-benefits__item" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("span", { staticClass: "c-product-benefits__text" }, [
      _vm._v(_vm._s(_vm.shippingText)),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "c-product-benefits__image" }, [
      _c("i", { staticClass: "ico ico-truck" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }